import { motion } from 'motion/react';
import { BaseComponentProps, HeaderContentProps } from '../../../types';
import { LastUpdatedTag } from './last-updated-tag';

type HealthDataHeaderCardProps = BaseComponentProps &
  HeaderContentProps & {
    variant?: 'default' | 'editor';
  };

export function HealthDataHeaderCard({
  heroContent,
  titleContent,
  children,
  variant = 'default',
}: HealthDataHeaderCardProps) {

  return (
    <div className="relative z-10 mx-auto max-w-7xl px-4 pt-14 pb-8 sm:px-6 md:pt-16 md:pb-12 lg:px-8">
      {/* Card container */}
      <motion.div
        className="rounded-2xl bg-[rgba(255,255,255,0.08)] p-6 backdrop-blur-sm md:p-8 relative overflow-hidden"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        {/* Background grid pattern */}
        <div
          className="absolute inset-0 opacity-54 pointer-events-none bg-[url('/images/bg-points.svg')] bg-center bg-[length:100%] bg-no-repeat md:hidden"
          style={{
            backgroundPositionY: '10%',
          }}
        />

        <div
          className={`flex min-h-[250px] relative z-10 ${variant === 'editor' ? 'flex-col gap-0' : 'flex-col lg:flex-row lg:gap-12'}`}
        >
          {/* Left side content */}
          <div
            className={`flex flex-shrink-0 flex-col items-center gap-6 ${
              variant === 'editor' ? 'order-1' : 'order-2 lg:order-1 lg:items-center'
            }`}
          >
            <div className="md:hidden">
              <LastUpdatedTag/>
            </div>
            {heroContent && (
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                {heroContent}
              </motion.div>
            )}
          </div>

          {/* Right side content - fills remaining space */}
          <div
            className={`flex flex-1 flex-col justify-center ${variant === 'editor' ? 'order-1' : 'order-1 lg:order-2'}`}
          >
            {titleContent && <div className="flex h-full flex-col justify-center">{titleContent}</div>}
            {children}
          </div>
        </div>
      </motion.div>
    </div>
  );
}
